import { Component, ElementRef, HostListener, Input, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core'
import { FileShowingComponent } from '../file-showing-component'
import { DomSanitizer } from '@angular/platform-browser'
import { Content } from '@monorepo/golab-generated'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'

export enum DisplayOptions {
  image = 'image',
  pdf = 'pdf',
  video = 'video',
  audio = 'audio',
  link = 'link',
  none = 'none',
}

const headerBarHeight = 64
const topWhiteSpace = 44
const bottomWhiteSpace = 44
const heightOverhead = headerBarHeight + topWhiteSpace + bottomWhiteSpace

@Component({
  selector: 'app-file-content',
  templateUrl: './file-content.component.html',
  styleUrls: ['./file-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, MatButton],
})
export class FileContentComponent extends FileShowingComponent {
  DisplayOptions = DisplayOptions
  displayOption = DisplayOptions.none

  constructor() {
    const sanitizer = inject(DomSanitizer);

    super(sanitizer)
  }

  @Input() set content(content: Content | undefined) {
    if (content) {
      this.setFileProperties(content)
    }
  }

  private _pdfViewer: ElementRef<HTMLObjectElement> | undefined

  @ViewChild('pdfViewer') set pdfViewer(pdfViewer: ElementRef<HTMLObjectElement>) {
    if (pdfViewer) {
      this._pdfViewer = pdfViewer
      setTimeout(() => {
        this.adjustPdfViewerHeightToAvailableWidth()
      }, 0)
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.adjustPdfViewerHeightToAvailableWidth()
  }

  private setFileProperties(content: Content): void {
    this.setUrl(content)
    this.displayOption = this.findDisplayOption(this.url)
  }

  private findDisplayOption(url: string): DisplayOptions {
    if (!url) {
      return DisplayOptions.none
    }
    const [, fileExtension] = this.splitFileName(this.url.toLowerCase())
    switch (fileExtension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'bmp':
      case 'svg':
      case 'webp':
        return DisplayOptions.image
      case 'pdf':
        return DisplayOptions.pdf
      case 'mp4':
      case 'webm':
      case 'mov':
      case 'avi':
        return DisplayOptions.video
      case 'mp3':
      case 'mpeg':
        return DisplayOptions.audio
      default:
        return DisplayOptions.link
    }
  }

  private adjustPdfViewerHeightToAvailableWidth() {
    if (!this._pdfViewer) {
      return
    }
    const windowHeight = window.innerHeight
    const newHeight = windowHeight - heightOverhead
    this._pdfViewer.nativeElement.style.height = `${newHeight}px`
    console.log('newHeight', newHeight)
  }
}
